<template>
  <div class="page">
    <div class="locations-grey locations-generic links">
      <section>

<a href="https://www.fpdcc.com/">
    Forest Preserves of Cook County
</a>   — One of the oldest and largest forest preserve districts in the United States, receives an estimated 62 million visits per year and provides a readily-accessible escape to a world teeming with wildlife and rich with outdoor recreation and environmental education opportunities. With 70,000 acres to explore and hundreds of events year-round, there are many ways for people of all ages and interests to experience nature, get active, or simply relax. 
<br><br>
<a href="https://www.fotfp.org">
    Friends of the Forest Preserves
    </a> — Unites people to protect, promote, and care for the forest preserves in Cook County. An independent nonprofit organization focused solely on the forest preserves in Cook County, it works to safeguard and improve the 70,000 acres of forest preserves for all of us, and for generations to come. 
<br><br>
<a href="http://www.clarkpark.net/">
    Clark Park Advisory Council
    </a> — Clark Park’s natural river front, boathouse, Nature Play Area, playing fields and bike trails sit on land once occupied by Riverview Amusement Park. Created in 1904, Riverview was, for a time, the world's largest amusement park. Today, the Advisory Council works to promote Clark Park and its adjacent properties as a public recreation area and green space to protect wildlife habitat. 
<br><br>
<a href="https://www.chicagoparkdistrict.com">
    Chicago Park District 
</a> — Owning and operating almost 9,000 acres of green space, the Chicago Park District is largest municipal park manager in the nation. More than 600 parks, 50 outdoor pools, 28 indoor pools, 24 swimming beaches, and 26 miles of lakefront provide sports and recreational activities as well as cultural and environmental programming for youth, adults, and seniors. 
<br><br>
<a href="https://www.chicagoriver.org">
    Friends of the Chicago River
</a> — Since 1979, Friends has been working to improve the health of the Chicago River system for the benefit of people and wildlife and, by doing so, has laid the foundation for the river to be a continuous, attractive, easily accessible corridor of open space in the Chicago region. 
      </section>
  </div>
  </div>
</template>

<script>
export default {
  name: 'links',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.links {
 width: 80%;
}
@media screen and (max-width: 768px) {
  .links {
    width: 90%;
  }
}
.page {
  background-image: url("../../assets/home.jpg");
  flex-direction: column;
  padding-left: 20px;
  align-items: center;
}
section {
  margin-bottom: 10px;
}
a:hover {
  color: #9f001c !important;
}
a {
color: white;   
}
</style>
